import { axios } from '@/plugins/axios';

export function validateStaffToken(token) {
    return axios.post('/staff-token', { token });
}
